import Handlebars from 'handlebars';

// Make Handlebars available globally
window.Handlebars = window.Handlebars || Handlebars;

// Filters List Partial
const filtersListPartial = `
<ul class="c-filter-list {{#if (hasSelectedChild filters)}}has-selected-child{{/if}}">
    {{#each filters}}
        <li>
            <button class="c-filter-list__btn {{#if selected}}is-selected{{/if}}" data-facet-list="{{facetList}}" data-facet-key="{{facetKey}}" type="button">
                <span>{{title}}</span> <span>{{total}}</span>
            </button>
        </li>
    {{/each}}
</ul>
`;

Handlebars.registerPartial("filters-list", filtersListPartial);

// Missing Author Partial
const missingAuthorPartial = `
<div class="missing-author">
    <div class="missing-author__bg">
        <div class="b-lazy" data-src="{{thumbnail}}"></div>
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAQAAACWCLlpAAAA3klEQVR42u3QQREAAAwCoNm/9Cr49iACOWpRIEuWLFmyZCmQJUuWLFmyFMiSJUuWLFkKZMmSJUuWLAWyZMmSJUuWAlmyZMmSJUuBLFmyZMmSpUCWLFmyZMlSIEuWLFmyZCmQJUuWLFmyFMiSJUuWLFkKZMmSJUuWLAWyZMmSJUuWAlmyZMmSJUuBLFmyZMmSpUCWLFmyZMlSIEuWLFmyZCmQJUuWLFmyFMiSJUuWLFkKZMmSJUuWLAWyZMmSJUuWAlmyZMmSJUuBLFmyZMmSpUCWLFmyZMlSIEuWLFmbHrcjAJdeLWiCAAAAAElFTkSuQmCC" alt="">
    </div>
    <svg class="missing-author__svg" viewBox="0 0 100 100" width="80%" height="80%">
        <defs>
            <mask id="mask-{{maskId}}">
                <rect class="missing-author__mask-rect" width="100%" height="100%"></rect>
                <svg class="missing-author__mask-svg" x="50%" y="50%">
                    <text x="0" y="15" text-anchor="middle">{{initials}}</text>
                </svg>
            </mask>
        </defs>
        <circle class="missing-author__circle" mask="url(#mask-{{maskId}})" cx="50" cy="50" r="50"></circle>
    </svg>
</div>
`;

Handlebars.registerPartial("missing-author", missingAuthorPartial);

export default Handlebars;
